module.exports = __webpack_public_path__ + "img/skinwash_step1.5d35da24.jpg";